import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const navLinkStyle = {
  fontWeight: 600,
  color: '#2b2b2b',
  margin: '0 5px',
  position: 'relative',
  textDecoration: 'none',
  padding: '4px 2px',
  transition: 'color 0.3s ease, transform 0.3s ease',
  display: 'inline-block',
};

const navLinkHoverStyle = {
  color: '#FF8C00',
  transform: 'translateY(-2px)',
  textShadow: '0 0 12px rgba(255,140,0,0.4)',
};

function AnimatedNavLink({ to, children, onClick }) {
  const [hovered, setHovered] = useState(false);
  return (
    <NavLink
      to={to}
      onClick={onClick}
      style={({ isActive }) => ({
        ...navLinkStyle,
        ...(hovered || isActive ? navLinkHoverStyle : {}),
      })}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {children}
      <span style={{
        position: 'absolute',
        bottom: '-2px',
        left: hovered ? '0' : '50%',
        width: hovered ? '100%' : '0',
        height: '2px',
        background: 'linear-gradient(90deg, #FFB347, #FF8C00)',
        borderRadius: '4px',
        transition: 'width 0.35s ease, left 0.35s ease',
        boxShadow: '0 0 6px rgba(255,140,0,0.5)',
        display: 'block',
      }} />
    </NavLink>
  );
}

export default function Navbar() {
  const [isOpen, setIsOpen] = useState(false);

  const toggleCollapse = () => {
    setIsOpen(!isOpen);
  };

  const closeMenu = () => {
    setIsOpen(false);
  };

  return (
    <nav class="navbar navbar-light navbar-expand-lg fixed-top py-3">
      <div class="container">
        <Link class="navbar-brand" to="/" onClick={closeMenu}>
          <img src="/shivam motor logo.jpeg" alt="Shivam Moto Logo" class="navbar-logo" />
        </Link>
        <button 
          class="navbar-toggler" 
          type="button" 
          onClick={toggleCollapse}
          aria-controls="navbarMain" 
          aria-expanded={isOpen} 
          aria-label="Toggle navigation"
        >
          <span class="navbar-toggler-icon"></span>
        </button>
        <div class={`collapse navbar-collapse ${isOpen ? 'show' : ''}`} id="navbarMain">
          <ul class="navbar-nav ms-auto mb-2 mb-lg-0 gap-2">
            <li class="nav-item">
              <AnimatedNavLink to="/" onClick={closeMenu}>Home</AnimatedNavLink>
            </li>
            <li class="nav-item">
              <AnimatedNavLink to="/new-bikes" onClick={closeMenu}>New Bikes</AnimatedNavLink>
            </li>
            <li class="nav-item">
              <AnimatedNavLink to="/old-bikes" onClick={closeMenu}>Old Bikes</AnimatedNavLink>
            </li>
          </ul>
          <Link 
            to="/exchange" 
            class="btn btn-sm btn-outline-dark mt-3 mt-lg-0 ms-lg-3 px-3 rounded-pill d-block d-lg-inline-block text-center"
            onClick={closeMenu}
          >
            Sell / Exchange
          </Link>
        </div>
      </div>
    </nav>
  );
}
